
import axios from "axios";
import { CannedDates, ClinicalReportType, ClinicalSummaryLogCriteria, ClinicalSummaryTemplate, 
    FacilityProperties, FormResponseShowType, KeyValuePairOfIntegerAndString, LabReportHeader, PatientDocumentCategories, PatientForm, PermissionType, Tag } from '../../../types/Sapphire_dto';
import Vue from "vue";
import { validate, extend,  ValidationProvider, ValidationObserver} from "vee-validate";
import { required, min } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required",
});
extend("min", {
  ...min,
  message: "This field must be more than 3 characters.",
});
const EHRClinicalReportPopup =  Vue.extend({
    name: "ehr-clinical-popup",
    components: {
        ValidationProvider
    },
    props: {
        patientID: Number
    },
    data: function () {
        return {
            invalid: false,
            FormResponseShowType,
            isDocumentAlreadyPendingResult: false,
            noTemplateShowing: true,
            saveReportSearch: false,
            searchTitle: '',
            title: 'Generate Clinical Doc',
            logCriteria: new Object() as ClinicalSummaryLogCriteria,
            facSettings: new Object() as FacilityProperties,
            PermissionType,
            ClinicalReportType,
            permissions: [] as PermissionType[],
            reportTabIndex: 0,
            openPopup: false,
            dateFrom: '',
            dateTo: '',
            //presetDateSelected: null as CannedDates,
            presetDateOptions: [] as KeyValuePairOfIntegerAndString[],            
            mhuDateList: [] as KeyValuePairOfIntegerAndString[],           
            selectedLabResultsRadioGroup: 1,
            medicationListSelected: [],
            labCount: 0,
            specificLabReportsList: [] as LabReportHeader[],           
            Groups: [] as PatientDocumentCategories[],
            Tags: [] as Tag[],
            selectedFormResponseRadioGroup: 1,
            specificFormResponseList: [] as PatientForm[],
            selectedFormResponseList: [] as PatientForm[],
            restrictionsExist: false,
            ShowPatientDocumentsCheckbox: false,
            IncludePatientDocumentsCheckbox: false,
            selectedPatDocGroup: 1,
            docDownloadOptions: [
                {text: 'Merge PDFs, zip all other documents', value: 0},
                {text: 'Zip all documents into zip file', value: 1},
            ],
            enterReportNote: false,
            facilitySearches: [] as ClinicalSummaryTemplate[], 
            searchFields: [
                {
                    key: "Payload",
                    label: "Title",
                    sortable: true,
                    formatter: (value: any) => {
                        let v: ClinicalSummaryLogCriteria = JSON.parse(value);
                        return v.Name;
                    },
                },
                {
                    key: "USERNAME",
                    label: "Created By",
                    sortable: true,
                },
                {
                    key: "CreateDate",
                    label: "Create Date",
                    sortable: true,
                    formatter: (value: any) => {
                        return getFormattedDate(value);
                    },
                },
                { key: "actions", label: "Actions" },
            ], 
            taskStatusOptions: [
                { text: 'Active', value: '0' },
                { text: 'Addressed', value: '1' },
                { text: 'Both', value: '2' }
            ], 
            formShowTypes: [
                {Key: 0, Value: 'Standard' },
                {Key: 1, Value: 'Redacted' },
                {Key: 2, Value: 'Answers Only'}
            ]
        };
    },
    mounted: function () {
        this.init();
    },
    watch: {
        "logCriteria.PresetCannedDate": function (newVal, oldVal) {
            if (newVal != oldVal) {
                this.setDateRange(newVal);
            }
        },
        dateFrom: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.setDateAfter(newVal);
            }
        },
        dateTo: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.setDateTo(newVal);
           }
        },
    },
    methods: {
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
       linkClass(idx) {
            if (this.reportTabIndex === idx) {
            return ['bg-primary', 'text-light']
            } else {
            return ['bg-light', 'text-info']
            }
        },
        async init() {
            await this.getGroups();
            await this.getTags();
            const response = await axios.post("../../Common/Services/EhrTaskService.svc/GetCannedDates",
            {   patientID:  this.patientID },
            );
            this.presetDateOptions = JSON.parse(response.data.d);
            await this.getPermissions();
            await this.getFacSettings();
        },
        async showPopup(savedCriteria?: ClinicalSummaryTemplate) {
            this.openPopup = true;
            this.noTemplateShowing = true;
            this.saveReportSearch=false;

            this.getMHUList();
            this.getLabCount();
            this.getSpecificLabReportsList();
            this.getSpecificFormResponsesList();
            this.showRestrictions();
            this.selectedFormResponseList = [];

            this.logCriteria = {
                Id: 0,
                PatID: this.patientID.toString(),
                showImmunizations: false,
                showMedications: true,
                showInactiveMedications: false,
                showProblemList: true,
                showInactiveProblems: false,
                showLabResults: true,
                showMHUChartSummary: false,
                showVitals: true,
                showNotes: true,
                ShowReleasedMeds: false,
                showPatientMessages: true,
                showPatientTasks: false,
                showFormResponses: true,
                showRedactedResponses: false,
                showSpecificFormResponses: false,
                FormShowType: FormResponseShowType.Standard,
                showConsultDocs: false,
                showRestrictions: true,
                showDocuments: true,
                includeAllUploadedPDFs: true,
                showTBReport: true,
                saveReportAsPatientDoc: false,
                getFullRecord: false,
                isEmergencyReport: false,
                isReleaseReport: false,
                patientDocIncludedOption: 0,
                ReportNotes: '',
                generateCCD: false,
                generateDentalReport: false,
                PresetCannedDate: CannedDates.Prev30Days,
                showFullLabResults: true,
                showSpecificLabResults: false,
                MedicationsAfter: '',
                LabResultsAfter: '',
                NotesAfter: '',
                VitalsAfter: '',
                ConsultDocsAfterDate: '',
                PatientDocUploadedAfter: '',
                TBAfterDate: '',
                MessagesAfter: '',
                MedicationsTo: '',
                LabResultsTo: '',
                NotesTo: '',
                VitalsTo: '',
                ConsultDocsToDate: '',
                PatientDocUploadedTo: '',
                TBToDate: '',
                MessagesTo: '',
                TasksAfter: '',
                TasksTo: '',
                SelectedTaskStatus: '0',
                SelectedSpecificFormResponsesForPrinting: ''
            }

            if (savedCriteria) {
                this.noTemplateShowing = false;
                this.fillLogCriteria(savedCriteria);
            } else {
                //  This is the default (not from a template).
                this.selectedFormResponseRadioGroup = 1;
                this.selectedLabResultsRadioGroup = 1;
                this.medicationListSelected = ['showMeds'];
                this.enterReportNote = false;
                this.setDateRange(CannedDates.Prev30Days);
            }
            this.reportTabIndex=0;

        },
        async fillLogCriteria(savedTemplate: ClinicalSummaryTemplate) {
            let savedCriteria: ClinicalSummaryLogCriteria = JSON.parse(savedTemplate.Payload);
            this.logCriteria.Name= savedCriteria.Name;
            this.logCriteria.showImmunizations= savedCriteria.showImmunizations;
            this.logCriteria.showMedications= savedCriteria.showMedications;
            this.logCriteria.showInactiveMedications= savedCriteria.showInactiveMedications;
            this.logCriteria.showProblemList= savedCriteria.showProblemList;
            this.logCriteria.showInactiveProblems= savedCriteria.showInactiveProblems;
            this.logCriteria.showLabResults= savedCriteria.showLabResults;

            this.logCriteria.showMHUChartSummary= savedCriteria.showMHUChartSummary;
            this.logCriteria.showVitals= savedCriteria.showVitals;
            this.logCriteria.showNotes= savedCriteria.showNotes;
            this.logCriteria.ShowReleasedMeds= savedCriteria.ShowReleasedMeds;
            this.logCriteria.showPatientMessages= savedCriteria.showPatientMessages;
            this.logCriteria.showPatientTasks = savedCriteria.showPatientTasks;
            this.logCriteria.showFormResponses= savedCriteria.showFormResponses;
            this.logCriteria.showRedactedResponses= savedCriteria.showRedactedResponses;
            this.logCriteria.showSpecificFormResponses= savedCriteria.showSpecificFormResponses;
            this.logCriteria.showConsultDocs= savedCriteria.showConsultDocs;
            this.logCriteria.showRestrictions= savedCriteria.showRestrictions;
            this.logCriteria.showDocuments= savedCriteria.showDocuments;
            this.logCriteria.includeAllUploadedPDFs= savedCriteria.includeAllUploadedPDFs;
            this.logCriteria.showTBReport= savedCriteria.showTBReport;

            this.logCriteria.getFullRecord= savedCriteria.getFullRecord;
            this.logCriteria.isEmergencyReport= savedCriteria.isEmergencyReport;
            this.logCriteria.isReleaseReport= savedCriteria.isReleaseReport;

            // Bug 21324:  Saved Templates: Clinical Document
            this.selectedLabResultsRadioGroup = this.logCriteria.showSpecificLabResults ? 2 : 1;
            this.selectedFormResponseRadioGroup = this.logCriteria.showSpecificFormResponses ? 2 : 1;

            this.logCriteria.PresetCannedDate=savedTemplate.PresetCannedDate;
            this.setDateRange(savedTemplate.PresetCannedDate);
        },
        async showRestrictions() {
            const response = await axios.post("../../Common/Services/EmarClientOperations.svc/DoRestrictionsExist",
            {   patientID:  this.patientID },
            );
            this.restrictionsExist = JSON.parse(response.data.d);  
        },
        async getPermissions() {
            const response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetUserPermissions")
            this.permissions = JSON.parse(response.data.d);      
        },
        async getFacSettings() {
            const response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetFacilitySettings")
            this.facSettings = JSON.parse(response.data.d);      
        },
        async getTags() {
            const response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetAllTagsTS")
            this.Tags = JSON.parse(response.data.d);      
        },
        async getGroups() {
            const response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetAllGroupsTS")
            this.Groups = JSON.parse(response.data.d);      
        },
        async getMHUList() {
            const response = await axios
                .post("../../Common/Services/EhrTaskService.svc/GetMHUList",
                {
                    patientID: this.patientID,
                });
            this.mhuDateList = JSON.parse(response.data.d);
        },
        async getSpecificLabReportsList() {
            const response = await axios
                .post("../../Common/Services/EhrTaskService.svc/GetSpecificLabResultsList",
                {
                    patientID: this.patientID,
                });
            this.specificLabReportsList = JSON.parse(response.data.d);
        },
        async getLabCount() {
            const response = await axios
                .post("../../Common/Services/EhrTaskService.svc/GetLabCount",
                {
                    patientID: this.patientID,
                });
            this.labCount = JSON.parse(response.data.d);
        },
        async getSpecificFormResponsesList() {
            let tags = this.logCriteria.SelectedFormResponseTagsVue ? this.logCriteria.SelectedFormResponseTagsVue.map(function(val) { return val.ID; }).join(',') : '';
            let groups = this.logCriteria.SelectedFormResponseGroupsVue ? this.logCriteria.SelectedFormResponseGroupsVue.map(function(val) { return val.DocumentCategoryID; }).join(',') : '';
            let excludeTags = this.logCriteria.SelectedFormResponseTagsExcludeVue ? this.logCriteria.SelectedFormResponseTagsExcludeVue.map(function(val) { return val.ID; }).join(',') : '';
            let excludeGroups = this.logCriteria.SelectedFormResponseGroupsExcludeVue ? this.logCriteria.SelectedFormResponseGroupsExcludeVue.map(function(val) { return val.DocumentCategoryID; }).join(',') : '';

            const response = await axios
                .post("../../Common/Services/EhrTaskService.svc/GetSpecificFormResponseList",
                {
                    patientID: this.patientID,
                    tags: tags,
                    groups: groups,
                    tagsExclude: excludeTags,
                    groupsExclude: excludeGroups,
                });
            this.specificFormResponseList = JSON.parse(response.data.d);
        },
        hidePopup() {
            this.openPopup = false;
        },
        async onSaveClick(reportType: ClinicalReportType) {
            this.logCriteria.getFullRecord = false;
            this.logCriteria.isEmergencyReport = false;
            this.logCriteria.isReleaseReport = false;

            if (this.selectedLabResultsRadioGroup == 2) {
                this.logCriteria.showSpecificLabResults = true;
                this.logCriteria.showFullLabResults = false;
            }

            if (this.selectedFormResponseRadioGroup== 2 && this.selectedFormResponseList.length > 0) {
                this.logCriteria.showSpecificFormResponses = true;
                //Add the list of the selected Form Response IDs to the logCriteria.
                this.logCriteria.SelectedSpecificFormResponsesForPrinting = this.selectedFormResponseList.map( f => f.ID ).join(', ')
            }
            
            switch(reportType) {
            case ClinicalReportType.FullRecord:
                this.logCriteria.getFullRecord = true;
                break;
            case ClinicalReportType.Emergency:
                this.logCriteria.isEmergencyReport = true;
                break;
            case ClinicalReportType.Release:
                this.logCriteria.isReleaseReport = true;
            }

            let pendingExists = 0;
            const response = await axios.post("../../Common/Services/EhrTaskService.svc/IsDocumentAlreadyPendingResult",
                {
                    patientID: this.patientID,
                    reportType: reportType
                }
            );
            pendingExists = response.data.d;

            if (pendingExists == 1) {
                this.$swal('PENDING REPORT EXISTS WARNING', 'There is currently a pending report for this patient.  The report will be available from the Clinical Documents Browser when completed.', 'warning');
            }
            else if (pendingExists == 2) {
                this.$swal('RECENT REPORT EXISTS WARNING', 'A Record was successfully created less than 1 hour ago for this patient.  The report is available from the Clinical Documents Browser page.', 'warning');
            }
            else {
                await axios.post("../../Common/Services/EhrTaskService.svc/SaveClinicalReport",
                {
                    criteria: JSON.stringify(this.logCriteria),
                    saveAsTemplate: JSON.stringify(this.saveReportSearch)
                }
                );
                this.hidePopup();
            }
        },
        async getFacilitySearchList() {
            this.facilitySearches.length = 0;

            const response = await axios.post("../../Common/Services/EhrTaskService.svc/GetSavedFacilitySearchList");
            this.facilitySearches = JSON.parse(response.data.d);
        },
        async deleteSearch(savedCriteria: ClinicalSummaryLogCriteria ){
            await axios.post("../../Common/Services/EhrTaskService.svc/DeleteClinicalSummaryCriteria",
                {
                    id: savedCriteria.Id
                }
            );
            await this.getFacilitySearchList();
        },
        setDateRange(presetDate: CannedDates) {
            let facNow = new Date();
            var timeOffsetInMS:number = facNow.getTimezoneOffset() * 60000;
            facNow.setTime(facNow.getTime() + timeOffsetInMS);

            let start = 0, end = 0, y = 0, m = 0, yest = 0, tom = 0;
            let facStart = new Date(facNow);
            let facEnd = new Date(facNow);

            switch (presetDate) {
                case CannedDates.Today:
                    this.dateFrom = facStart.toISOString().split('T')[0];
                    this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.Yesterday:
                    yest = facNow.getDate() - 1;
                    facStart.setDate(yest);
                    facEnd.setDate(yest);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                    this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.Tomorrow:
                    tom = facNow.getDate() + 1;
                    facStart.setDate(tom);
                    facEnd.setDate(tom);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                    this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.LastWeek:
                    start = (facNow.getDate() - 7) - facNow.getDay();
                    facStart.setDate(start);
                    end = start + 7;
                    facEnd.setDate(end);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                    this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.ThisWeek:
                    start = facNow.getDate() - facNow.getDay();
                    facStart.setDate(start);
                    end = start + 7;
                    facEnd.setDate(end);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                    this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.NextWeek:
                    start = (facNow.getDate() + 7) - facNow.getDay();
                    facStart.setDate(start);
                    end = start + 7;
                    facEnd.setDate(end);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                    this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.Next30Days:
                    end = facNow.getDate() + 30;
                    facEnd.setDate(end);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                     this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.Next60Days:
                    end = facNow.getDate() + 60;
                    facEnd.setDate(end);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                     this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.Next90Days:
                    end = facNow.getDate() + 90;
                    facEnd.setDate(end);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                    this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.Next180Days:
                    end = facNow.getDate() + 180;
                    facEnd.setDate(end);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                     this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.LastMonth:
                    start = facNow.getMonth() - 1;
                    facStart.setDate(start);
                    y = facStart.getFullYear(), m = facStart.getMonth();                    
                    this.dateFrom = new Date(y, m, 1).toISOString().split('T')[0];
                    this.dateTo = new Date(y, m + 1, 0).toISOString().split('T')[0];
                    break;                
                case CannedDates.ThisMonth:
                    start = facNow.getMonth();
                    facStart.setDate(start);
                    y = facStart.getFullYear(), m = facStart.getMonth();                    
                    this.dateFrom = new Date(y, m, 1).toISOString().split('T')[0];
                    this.dateTo = new Date(y, m + 1, 0).toISOString().split('T')[0];
                    break;                
                case CannedDates.NextMonth:
                    start = facNow.getMonth() + 1;
                    facStart.setDate(start);
                    y = facStart.getFullYear(), m = facStart.getMonth();                    
                    this.dateFrom = new Date(y, m, 1).toISOString().split('T')[0];
                    this.dateTo = new Date(y, m + 1, 0).toISOString().split('T')[0];
                    break;                
                case CannedDates.LastYear:
                    start = facNow.getFullYear() - 1;
                    this.dateFrom = new Date(start, 0, 1).toISOString().split('T')[0];
                    this.dateTo = new Date(start, 11, 31).toISOString().split('T')[0];
                    break;                
                case CannedDates.ThisYear:
                    start = facNow.getFullYear();
                    this.dateFrom = new Date(start, 0, 1).toISOString().split('T')[0];
                    this.dateTo = new Date(start, 11, 31).toISOString().split('T')[0];
                    break;                
                case CannedDates.NextYear:
                    start = facNow.getFullYear() + 1;
                    this.dateFrom = new Date(start, 0, 1).toISOString().split('T')[0];
                    this.dateTo = new Date(start, 11, 31).toISOString().split('T')[0];
                    break;
                case CannedDates.All:
                    this.dateFrom = "1900-01-01"
                    this.dateTo = "3000-01-01"
                    break;
                case CannedDates.Prev30Days:
                    start = facNow.getDate() - 31;
                    facStart.setDate(start);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                    this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.Prev60Days:
                    start = facNow.getDate() - 61;
                    facStart.setDate(start);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                    this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.Prev90Days:
                    start = facNow.getDate() - 91;
                    facStart.setDate(start);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                    this.dateTo = facEnd.toISOString().split('T')[0];
                    break;                
                case CannedDates.Prev180Days:
                    start = facNow.getDate() - 181;
                    facStart.setDate(start);
                    this.dateFrom = facStart.toISOString().split('T')[0];
                    this.dateTo = facEnd.toISOString().split('T')[0];
                    break;
            }
            this.setDateAfter(this.dateFrom);
            this.setDateTo(this.dateTo);
        },
        setDateAfter(thisDateAfter = '') {
            this.logCriteria.MedicationsAfter= thisDateAfter;
            this.logCriteria.LabResultsAfter = thisDateAfter;
            this.logCriteria.NotesAfter = thisDateAfter;
            this.logCriteria.VitalsAfter = thisDateAfter;
            this.logCriteria.ConsultDocsAfterDate = thisDateAfter;
            this.logCriteria.PatientDocUploadedAfter = thisDateAfter;
            this.logCriteria.TBAfterDate = thisDateAfter;
            this.logCriteria.MessagesAfter = thisDateAfter;
            this.logCriteria.TasksAfter = thisDateAfter;
        },
        setDateTo(thisDateTo = '') {
            this.logCriteria.MedicationsTo= thisDateTo;
            this.logCriteria.LabResultsTo = thisDateTo;
            this.logCriteria.NotesTo = thisDateTo;
            this.logCriteria.VitalsTo = thisDateTo;
            this.logCriteria.ConsultDocsToDate = thisDateTo;
            this.logCriteria.PatientDocUploadedTo = thisDateTo;
            this.logCriteria.TBToDate = thisDateTo;
            this.logCriteria.MessagesTo = thisDateTo;
            this.logCriteria.TasksTo = thisDateTo;
        }
    }
});


export type EHRClinicalReportPopupRef = InstanceType<typeof EHRClinicalReportPopup>;
export default EHRClinicalReportPopup;

function getFormattedDate(value: string | number | Date) {
  var d = new Date(value);
  var minDate = new Date('01/01/0001');
  if (!(d > minDate)) {
    return '';
  }

  var month = "" + (d.getMonth() + 1);
  var day = "" + d.getDate();
  var year = "" + d.getFullYear();

  //var hours = d.getHours();
  //var minutes = d.getMinutes();
  //var meridiem = d.getHours() > 12 ? "pm" : "am";

  //hours = hours % 12;
  //hours = hours ? hours : 12; // the hour '0' should be '12'
  //minutes = minutes < 10 ? "0" + minutes : minutes;

  //let timePart = "" + hours + ":" + minutes + " " + meridiem;

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  let dayPart = [month, day, year].join("/");

  return dayPart;
}
